import { useState } from 'react';
import { message, Modal, Radio } from 'antd';
import Input from '../../components/forms/Input';
import TextArea from 'antd/es/input/TextArea';
import Button from '../../components/forms/Button';

import { FaTimesCircle } from '@react-icons/all-files/fa/FaTimesCircle';

import './index.scss';
import { postRequest } from '../../services/requestService';

const FeedbackModal = props => {
    const [open, setOpen] = useState(false);
    const [params, setParams] = useState({ kind: '', status: 'draft' });
    const isDisabled = !params.title && !params.description;
    
    const onChange = (key, value) => {
        setParams({ ...params, [key]: value });
    };
    
    const onSubmit = async () => {
        if (isDisabled) return message.error(`Tell us about your experience`);
        try {
            await postRequest('user/feedback', { ...params, url: window.location.href });
        }
        catch (e) {
            console.error(e);
        }
        onChange('status', 'success');
    };
    
    const onClose = () => {
        setParams({ kind: '', status: 'draft', });
        setOpen(false);
    };
    
    const isVisible = !!["/dashboard", "/editor"].filter(a => a.includes(window.location.pathname)).length;
    if (!isVisible) return null;
    
    return (
        <>
            <div className="feedback-button" onClick={() => setOpen(true)}>
                Feedback?
            </div>
            <Modal className="feedback-modal" open={open} footer={null} closable={false}>
                <div className="header">
                    <div className="title">Ideas + 🪲 Bugs</div>
                    <div className="right" onClick={() => onClose()}>
                        <FaTimesCircle />
                    </div>
                </div>
                <br />
                {params.status === 'draft' ? <>
                    <Radio.Group
                        options={[{ label: 'Report a Bug', value: 'bug 🪲' }, { label: 'Suggest a feature', value: 'feature' }]}
                        buttonStyle="button"
                        onChange={(e) => onChange('kind', e.target.value)}
                        value={params.kind}
                    />
                    {params.kind && (
                        <>
                            <Input maxLength={3000} onChange={e => onChange('title', e.target.value)}
                                className="title-input" placeholder="Short, descriptive title"></Input>
                            <div className="label">Description</div>
                            <TextArea maxLength={5000}
                                onChange={e => onChange('description', e.target.value)}
                                className="description-input" placeholder="Any additional details..." />
                            <div className="footer">
                                <Button disabled={isDisabled} onClick={onSubmit}>Submit</Button>
                            </div>
                        </>
                    )}
                </> : <div className="success">
                    <div>Thank you for sharing your feedback and helping us build Get In Genie! Our team will review it within the next 24-48 hours. We hope enjoy the app</div>
                    <br />
                    <Button onClick={() => onClose()}>Close</Button>
                </div>}
            </Modal>
        </>
    );
};

export default FeedbackModal;